import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/app.css"; // Tailwind v4 tokens + utilities
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ApolloProvider } from "@apollo/client/react";
import apolloClient from "./apollo/client";
import { ThemeProvider } from "./components/theme-provider";
import { CookieManager } from "react-cookie-manager";
import { cookieManagerClassNames, cookieManagerTranslations } from "./consent/config";

const container = document.getElementById("root");
if (!container) {
  throw new Error('Root container element with id "root" not found');
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <CookieManager
      cookieKey="cookie-consent.v1"
      initialPreferences={{ Analytics: false, Social: false, Advertising: false }}
      cookieCategories={{ Analytics: true, Social: true, Advertising: true }}
      translations={cookieManagerTranslations}
      classNames={cookieManagerClassNames}
      displayType="banner"
      theme="light"
      disableGeolocation
    >
      <ApolloProvider client={apolloClient}>
        <ThemeProvider defaultTheme={"system"} storageKey={"vite-ui-theme"}>
          <App />
        </ThemeProvider>
      </ApolloProvider>
    </CookieManager>
  </React.StrictMode>,
);

reportWebVitals();
